import { Logger } from '@frontend/logger';

import { Token } from './models';
import { getTokenExpirationMs } from './token-expiration';

export const REFRESH_BEFORE_EXPIRY_MS = 10 * 60 * 1000;

export type TokenRefreshHandler = () => void | Promise<void>;

export class TokenRefreshScheduler {
    private timeoutId?: NodeJS.Timeout | number;

    clear(): void {
        if (this.timeoutId !== undefined) {
            clearTimeout(this.timeoutId);
            this.timeoutId = undefined;
        }
    }

    schedule(token: Token, onRefresh: TokenRefreshHandler, logLabel: string): void {
        this.clear();

        const expirationTime = getTokenExpirationMs(token);
        if (expirationTime == null) {
            Logger.warn(`Could not determine ${logLabel} token expiration for refresh scheduling`);
            return;
        }

        const refreshTime = expirationTime - REFRESH_BEFORE_EXPIRY_MS;
        const timeUntilRefresh = refreshTime - Date.now();

        if (timeUntilRefresh <= 0) {
            Logger.warn(`${logLabel} token is already expired or will expire in less than 10 minutes, refreshing immediately`);
            void onRefresh();
            return;
        }

        Logger.log(`${logLabel} token will be refreshed in ${Math.floor(timeUntilRefresh / 1000 / 60)} minutes`);
        this.timeoutId = setTimeout(() => {
            void onRefresh();
        }, timeUntilRefresh);
    }
}
